import { BreakPoints } from '@kanda-libs/ks-design-library';
import type { ReactNode } from 'react';
import OptionPopoverDesktop from './Desktop';
import OptionPopoverMobile from './Mobile';

export interface OpenBankingInfoPopoverProps {
  children: ReactNode;
}

const OpenBankingInfoPopover: React.FunctionComponent<OpenBankingInfoPopoverProps> =
  function ({ children }) {
    return (
      <BreakPoints
        desktop={<OptionPopoverDesktop>{children}</OptionPopoverDesktop>}
        mobile={<OptionPopoverMobile>{children}</OptionPopoverMobile>}
      />
    );
  };

export default OpenBankingInfoPopover;
